module.exports = __webpack_public_path__ + "static/media/no-data-icon.54b65c49.svg";